export default "__VITE_ASSET__DB$qU70l__"